import { TopicTreeEditor } from "@/components/composer/TopicTreeEditor";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import type { ComponentProps } from "react";

type TopicTreeEditorProps = ComponentProps<typeof TopicTreeEditor>;

type Props = {
  workspaceId: TopicTreeEditorProps["workspaceId"];
  workspaceTier: TopicTreeEditorProps["workspaceTier"];
  framework: TopicTreeEditorProps["framework"];
  columns: TopicTreeEditorProps["columns"];
  principles: TopicTreeEditorProps["principles"];
  topics: TopicTreeEditorProps["topics"];
  onChange: TopicTreeEditorProps["onChange"];
};

export function FrameworkPanel({ workspaceId, workspaceTier, framework, columns, principles, topics, onChange }: Props) {
  return (
    <div className="p-4">
      <Card className="shadow-soft">
        <CardHeader>
          <CardTitle>Framework: Topic Tree</CardTitle>
          <CardDescription>
            Vertical Topic Tree: each column is one broad lane. Add topics as chips — specificity comes from the content you generate. Seeded with an Excerptus knowledge-worker methodology starter you can edit, replace, or simplify (for example, a basic Beginner / Intermediate / Advanced split).
          </CardDescription>
        </CardHeader>
        <CardContent>
          <TopicTreeEditor
            workspaceId={workspaceId}
            workspaceTier={workspaceTier}
            framework={framework}
            columns={columns}
            principles={principles}
            topics={topics}
            onChange={onChange}
          />
        </CardContent>
      </Card>
    </div>
  );
}
